import type { FaireProductEntity } from "../../entity_types/product";

export const p_a7q5uqfpvx: FaireProductEntity = {
  token: "p_a7q5uqfpvx",
  type: "product",
  name: "18K Gold PVD Stainless Steel Oval Huggie Earrings",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/bfd58b7c2928bd9c8e65e1ad2573e3033cd1265eee0859c75ebcb56845575db0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/195de2c33c2f646b4c5c0ce1f5ba31a83ce38d40aee3a001056d8304f3438025.jpeg",
    "https://cdn.faire.com/fastly/4f255702d9cd8be71da2fa1fb6e140e79b5fbaeec24f6725624e645447091433.jpeg",
    "https://cdn.faire.com/fastly/6718f17bcd20c5200e1e6ab3cfd3e0b8254b33e8ccb57115155b7048854d50f5.jpeg",
    "https://cdn.faire.com/fastly/1853a99768ebc5f43ef12786b41f35fab7748bb3473d361ca1851ebe20f3b728.jpeg",
    "https://cdn.faire.com/fastly/0d25811762e41318b6c8dfacad0e47731072f09195db600b7d4542243b437772.jpeg",
    "https://cdn.faire.com/fastly/71cba5bc3c2720187cb94dd462253c718651cc7875400e00544e5565d724f57c.jpeg",
    "https://cdn.faire.com/fastly/f0e83566a41d8fbf56651ed581d3db4f7a7d8b6c42367fed3ca603a3df3378e6.jpeg",
    "https://cdn.faire.com/fastly/d2bc791d344b5efc1c5a8af9c0bcd4dab1d879f073657d349f7deded8b76d494.jpeg",
    "https://cdn.faire.com/fastly/9354d71c96b3cf9f119258f70849bfe9800e3a89e18707a1242832499d634a19.jpeg",
    "https://cdn.faire.com/fastly/002379c19c536e380f52f94cbce17565b43dd9122478638e61b510705e9b9194.jpeg",
  ],
  priceDollars: 2.81,
  description:
    "Enhance your selection of jewelry for the season with the Oval Huggie Earrings! These simple, yet stunning huggie style hoops are versatile for a variety of occasions. The Oval Huggie Earrings are great as a stand alone seller, but are the perfect option to be paired with other huggies or stud earrings for a stacked look.\n\nExplore our complete Earring Collection to start building your own assortment of stacked earring looks!\n\n• Lightweight & perfect for everyday wear or special occasions!\n• Made with 316L Surgical Steel - Hypoallergenic, non-tarnish, 100% waterproof\n\n-𝐏𝐕𝐃 𝐂𝐨𝐚𝐭𝐢𝐧𝐠-\nWe use the process of PVD Coating our 18K Gold jewelry over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer's skin green.\n\n• Approx. Weight: 5.49 grams\n• Approx. Width: 3mm",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:54.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
